import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Play } from 'lucide-react';
import {
  SectionTitle,
  SectionSubtitle,
  SectionDescription,
  Section,
  SectionContent,
} from '../styles/sections';
import {
  SplitHeroSection,
  SplitHeroGrid,
  SplitHeroTextCol,
  SplitHeroMediaCol,
  SplitHeroMedia,
  PlayButtonOverlay,
  PlayButtonCircle,
} from '../styles/mediaHero';
import {
  TimelineWrapper,
  TimelineStep,
  TimelineNumber,
  TimelineContent,
  TimelineTitle,
  TimelineText,
} from '../styles/timeline';

const steps = [
  { title: 'Create Your Club', text: 'Set up your club in minutes and invite your committee.' },
  { title: 'Add Your Squad', text: 'Bring your players and members on board with a simpleinvite link.' },
  { title: 'Set Your Fines', text: 'Build your fine list once — Playfair handles the tracking from there.' },
  { title: "You're Live", text: 'Members log fines, get reminders, and pay in-app. No more chasing.' },
];

function GettingStartedPage() {
  return (
    <>
      <Helmet>
        <title>Getting Started | Playfair</title>
        <meta name="description" content="Watch how clubs get set up on Playfair in under five minutes." />
        <link rel="canonical" href="https://playfair.online/resources/getting-started" />
      </Helmet>

      <SplitHeroSection bg="#000">
        <SplitHeroGrid>
          <SplitHeroMediaCol>
            <SplitHeroMedia autoPlay muted loop playsInline>
              <source src="/footballHero.mp4" type="video/mp4" />
            </SplitHeroMedia>
            <PlayButtonOverlay>
              <PlayButtonCircle>
                <Play size={26} fill="#000000" />
              </PlayButtonCircle>
            </PlayButtonOverlay>
          </SplitHeroMediaCol>

          <SplitHeroTextCol>
            <SectionSubtitle style={{ color: '#fff' }}>Get Set Up Fast</SectionSubtitle>
            <SectionTitle style={{ color: '#fff' }}>Getting Started</SectionTitle>
            <SectionDescription style={{ color: '#fff', marginBottom: 0 }}>
              Watch how clubs get set up on Playfair in under five minutes.
            </SectionDescription>
          </SplitHeroTextCol>
        </SplitHeroGrid>
      </SplitHeroSection>

      <Section backgroundColor="#fff">
        <SectionContent>
          <TimelineWrapper>
            {steps.map((step, index) => (
              <TimelineStep key={step.title}>
                <TimelineNumber>{index + 1}</TimelineNumber>
                <TimelineContent>
                  <TimelineTitle>{step.title}</TimelineTitle>
                  <TimelineText>{step.text}</TimelineText>
                </TimelineContent>
              </TimelineStep>
            ))}
          </TimelineWrapper>
        </SectionContent>
      </Section>
    </>
  );
}

export default GettingStartedPage;
